export default "__VITE_ASSET__DxrLBRYt__"